import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('UI ErrorBoundary caught:', error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary" className="min-h-screen flex items-center justify-center bg-stone-50 p-6">
          <div className="max-w-md text-center bg-white border border-stone-200 rounded-lg shadow-sm p-8">
            <h1 className="font-heading text-2xl font-bold text-stone-900 mb-2">Something went wrong</h1>
            <p className="text-stone-600 text-sm mb-6">
              The screen hit an unexpected error. Your data is safe — please reload to continue.
            </p>
            <button
              data-testid="error-reload-button"
              onClick={this.handleReload}
              className="bg-primary text-white px-5 py-2.5 rounded-md text-sm font-semibold hover:opacity-90 transition-opacity"
            >
              Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
